import { render, staticRenderFns } from "./campaign-email-sms-template.vue?vue&type=template&id=113b74fc&"
import script from "./campaign-email-sms-template.vue?vue&type=script&lang=js&"
export * from "./campaign-email-sms-template.vue?vue&type=script&lang=js&"
import style0 from "./campaign-email-sms-template.vue?vue&type=style&index=0&id=113b74fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports